import NodeCache from "node-cache";
import Fuse from "fuse.js";
const cacheData = new NodeCache();

export const fetchCachedOrRealData = async (
  getData = () => {},
  name,
  timeoutInMinutes
) => {
  const reset = false;
  try {
    const value = cacheData.get(name);
    let result = {};
    const useCached = (value && !reset) || false;
    if (useCached) {
      result = value;
    } else {
      const data = await getData();
      cacheData.set(name, data, timeoutInMinutes * 60);
      result = data;
    }

    return { cached: useCached, ...result };
  } catch (err) {
    return { error: true, data: err };
  }
};

export function roughSizeOfObject(object) {
  var objectList = [];
  var stack = [object];
  var bytes = 0;

  while (stack.length) {
    var value = stack.pop();

    if (typeof value === "boolean") {
      bytes += 4;
    } else if (typeof value === "string") {
      bytes += value.length * 2;
    } else if (typeof value === "number") {
      bytes += 8;
    } else if (typeof value === "object" && objectList.indexOf(value) === -1) {
      objectList.push(value);

      for (var i in value) {
        stack.push(value[i]);
      }
    }
  }
  return fileSizeToString(bytes);
}
export const fileSizeToString = (size) => {
  var i =
    size > 0 ? Math.max(1, Math.floor(Math.log(size) / Math.log(1024))) : 0;

  return (
    (size / Math.pow(1024, i)).toFixed(2) * 1 +
    "" +
    ["B", "kB", "MB", "GB", "TB"][i]
  );
};

export function fuzzySearch(query, allProducts) {
  const options = {
    isCaseSensitive: false,
    includeScore: true,
    shouldSort: true,
    threshold: 0.05,
    ignoreLocation: true,
    keys: [
      "post_name",
      "post_title",
    ],
  };
  if (!allProducts) {
    return;
  }

  const fuse = new Fuse(allProducts, options);
  const results = fuse.search(query);

  //Remove results with only category "uncategorized"
  const filteredResults = results.filter(
    (result) => result.item?.categories?.[0]?.slug !== "uncategorized"
  );

  return filteredResults;
}